import KeenSlider from "keen-slider";
import event from "../lib/mixins/event";

class ImageCarousel {
	constructor(dom) {
		this.NAME = "ImageCarousel";
		this.dom = dom;
		this.slider = null;
	}

	init() {
		const sliderDom = this.dom.querySelector("[data-slider]");
		if (!sliderDom) return;

		const updateActive = (s) => {
			if (!s.track.details) return;
			const activeIdx = s.track.details.rel;
			s.slides.forEach((slide, i) => {
				slide.classList.toggle("is-active", i === activeIdx);
			});
		};

		this.slider = new KeenSlider(sliderDom, {
			loop: true,
			slides: { perView: 1.8, spacing: 8, origin: "center" },
			breakpoints: {
				"(min-width: 1024px)": {
					slides: { perView: "2.8", spacing: 10, origin: "center" },
				},
			},
			created: updateActive,
			slideChanged: updateActive,
			dragStarted: (s) => s.container.classList.add("is-dragging"),
			dragEnded: (s) => s.container.classList.remove("is-dragging"),
		});
	}

	destroy() {
		if (this.slider) {
			this.slider.destroy();
			this.slider = null;
		}
	}
}

Object.assign(ImageCarousel.prototype, event);
export default ImageCarousel;
